var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNew1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 126,
    viewBox: "0 0 109 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 54.238,
    cy: 54.238,
    r: 54.238,
    fill: "#D9D9D9",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.5714 41.3216C64.5714 38.9192 64.5714 37.718 64.3073 36.7324C63.5907 34.058 61.5017 31.969 58.8272 31.2524C57.8417 30.9883 56.6405 30.9883 54.2381 30.9883C51.8356 30.9883 50.6344 30.9883 49.6489 31.2524C46.9744 31.969 44.8854 34.058 44.1688 36.7324C43.9047 37.718 43.9047 38.9192 43.9047 41.3216M36.6714 77.4883H71.8047C74.6983 77.4883 76.1451 77.4883 77.2503 76.9251C78.2225 76.4298 79.0129 75.6394 79.5083 74.6672C80.0714 73.562 80.0714 72.1152 80.0714 69.2216V49.5883C80.0714 46.6947 80.0714 45.2479 79.5083 44.1427C79.0129 43.1705 78.2225 42.3801 77.2503 41.8847C76.1451 41.3216 74.6983 41.3216 71.8047 41.3216H36.6714C33.7778 41.3216 32.331 41.3216 31.2258 41.8847C30.2536 42.3801 29.4632 43.1705 28.9679 44.1427C28.4047 45.2479 28.4047 46.6947 28.4047 49.5883V69.2216C28.4047 72.1152 28.4047 73.562 28.9679 74.6672C29.4632 75.6394 30.2536 76.4298 31.2258 76.9251C32.331 77.4883 33.7778 77.4883 36.6714 77.4883Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_12318_330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0116 121.476L54.238 120.476L93.4644 121.476V122.425L54.238 123.425L15.0116 122.425V121.476Z",
    fill: "url(#paint0_linear_12318_330)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_12318_330",
    x: 13.0116,
    y: 118.476,
    width: 82.4528,
    height: 6.94922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_12318_330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12318_330",
    x1: 15.0116,
    y1: 121.951,
    x2: 93.4644,
    y2: 121.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0528846,
    stopColor: "#06378F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#85D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932692,
    stopColor: "#06378F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew1);
export default __webpack_public_path__ + "static/media/new-1.32c30989048c406561fb56e60789cea2.svg";
export { ForwardRef as ReactComponent };